import React from 'react';

import moment from 'moment-timezone';
import _ from 'lodash';

import { orderStatus, quoteStatus } from '../../utils/constant';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import request from '../../utils/request';
import FieldGuide from '../../form/fields/common/fieldGuide';
import Tooltip from '../../tooltip';
import { MessageLabel, MessageMain, MessageOrderLocked } from './css';

const getFinalStatus = statusOrder => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { status }
  } = localizedStrings;

  let finalStatus;
  let statusId;
  if (statusOrder === orderStatus.incomplete) {
    finalStatus = status.incomplete;
    statusId = 'incomplete';
  } else if (statusOrder === orderStatus.pendingValidation) {
    finalStatus = status.pendingValidation;
    statusId = 'pendingValidation';
  } else if (statusOrder === orderStatus.waitingOnSales) {
    finalStatus = status.waitingOnSales;
    statusId = 'waitingOnSales';
  } else if (statusOrder === orderStatus.waitingOnCredit) {
    finalStatus = status.waitingOnCredit;
    statusId = 'waitingOnCredit';
  } else if (statusOrder === orderStatus.contractSent) {
    finalStatus = status.contractSent;
    statusId = 'contractSent';
  } else if (statusOrder === orderStatus.contractSigned) {
    finalStatus = status.contractSigned;
    statusId = 'contractSigned';
  } else if (statusOrder === orderStatus.contractExpired) {
    finalStatus = status.contractExpired;
    statusId = 'contractExpired';
  } else if (statusOrder === orderStatus.orderCanceled) {
    finalStatus = status.orderCanceled;
    statusId = 'orderCanceled';
  } else if (statusOrder === orderStatus.withConcierge) {
    finalStatus = status.withConcierge;
    statusId = 'withConcierge';
  } else if (statusOrder === orderStatus.validated) {
    finalStatus = status.validated;
    statusId = 'validated';
  } else if (statusOrder === orderStatus.implementationInProgress) {
    finalStatus = status.implementationInProgress;
    statusId = 'implementationInProgress';
  } else if (statusOrder === orderStatus.waitingOnCompletionCall) {
    finalStatus = status.waitingOnCompletionCall;
    statusId = 'waitingOnCompletionCall';
  } else if (statusOrder === orderStatus.orderInstalled) {
    finalStatus = status.orderInstalled;
    statusId = 'orderInstalled';
  } else if (statusOrder === quoteStatus.approved) {
    finalStatus = status.quoteApproved;
    statusId = 'quoteApproved';
  } else if (statusOrder === orderStatus.orderSubmitted) {
    finalStatus = status.orderSubmitted;
    statusId = 'orderSubmitted';
  }
  return { finalStatus, statusId };
};

const getStatus = ({ status }) => {
  const localizedStrings = useLocalizedStringsContext();

  const {
    BUSINESS_APP_ORDERS: { statusToolTipMessage }
  } = localizedStrings;

  const { statusId, finalStatus } = getFinalStatus(status);
  const getToolTip = () => {
    const message = statusToolTipMessage[status];
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        {finalStatus}
        <FieldGuide tooltip={message} />
      </div>
    );
  };
  return { statusId, finalStatus, statusToolTip: getToolTip() };
};

const getMessage = data => {
  const { isContractResend, isOrderReturned, isLockedBy } = data;
  const { email } = request.getProfile();
  const localizedStrings = useLocalizedStringsContext();
  const {
    sovTableMessages: { resendContract, returnOrder }
  } = localizedStrings.ORDERS;
  return (
    <MessageMain>
      {isContractResend && <MessageLabel>{resendContract}</MessageLabel>}
      {isOrderReturned && <MessageLabel>{returnOrder}</MessageLabel>}
      {isLockedBy && isLockedBy !== email && (
        <MessageOrderLocked>{`This order is being currently worked on by ${isLockedBy}`}</MessageOrderLocked>
      )}
    </MessageMain>
  );
};

export const getLastComment = data => {
  const lastComment = _.get(data, 'orderComments.0.text', '');
  if (lastComment.length > 50) {
    let shortenedLastComment = lastComment.substring(0, 47);
    shortenedLastComment += '...';
    return (
      <>
        <Tooltip
          id={_.get(data, 'orderComments.0.id', '')}
          message={lastComment}
          icon="fa-info-circle"
        >
          {`${shortenedLastComment}`}
        </Tooltip>
      </>
    );
  }
  return lastComment;
};

const getLocalFormattedTime = (date, format = 'MM/DD/YYYY, hh:mm A') => {
  const localZone = moment.tz.guess();

  return `${moment
    .utc(date)
    .local()
    .format(format)} ${moment.tz.zone(localZone).abbr(360)}`;
};

export { getStatus, getMessage, getLocalFormattedTime };
